import TableCells from 'components/TableCells';
import PropTypes from 'prop-types';

import moveable from "actions/moveable";

import { ReactComponent as ArrowIcon } from 'icons/components/arrow.svg';
import CheckBox from "../CheckBox";


import './index.less';
import './themes/default.less';

export default class Table extends TableCells {
    static propTypes = {
        className: PropTypes.string,
        sort: PropTypes.string,
        map: PropTypes.object,
        items: PropTypes.array,
        onSortChange: PropTypes.func,
        headBlack1: PropTypes.bool,
        headTitle: PropTypes.bool,
        scrollNo: PropTypes.bool,
        cantSort: PropTypes.bool,
        transparentBorder: PropTypes.bool,
        useIndexes: PropTypes.func,
        useToplam: PropTypes.object,
        selectedRow: PropTypes.number,
    };

    static defaultProps = {
        className: "",
        sort: "",
        map: {},
        items: [],
        onSortChange: null,
        headBlack1: false,
        headTitle: false,
        scrollNo: false,
        cantSort: false,
        transparentBorder: false,
        useIndexes: null,
        useToplam: {},
        selectedRow: -1,
    };

    componentDidMount() {
        this.setHeaderHeight();
        if (this.props.handleScrollX?.apply)
            this._helper.on(this.domNode, "scroll", this.handleScrollX);
    }

    componentDidUpdate() {
        this.setHeaderHeight();
    }

    setHeaderHeight() {
        this.domNode.scrollTop = 0;
    }

    handleScrollX = () => {
        const scrollLeft = this.domNode.scrollLeft;
        if (this.props.handleScrollX?.apply)
            this.props.handleScrollX(scrollLeft);
    };

    changeSort(key) {
        let currKey = this.props.sort;
        let isDesc = false;
        if (currKey[0] === "-") {
            currKey = currKey.substring(1);
            isDesc = true;
        }

        if (key === currKey) {
            if (isDesc)
                key = "";
            else
                key = `-${key}`;
        }

        if (this.props.onSortChange?.apply)
            this.props.onSortChange(key);
    }

    _indexChangeStart(info, e) {
        moveable.setup(e, "row", this.props.useIndexes.bind(this, info));
    }

    clickCheck(cb) {
        const val = this["checkBoxMain"].value;
        this["checkBoxMain"].value = !val;

        Object.keys(this).forEach(it => {
            if (it.includes("checkBox") && it !== "checkBoxMain")
                this[it].value = !val;
        });

        if (cb?.apply)
            cb("checkBoxMain", !val);
    }

    renderCells(isHeader, map, info, isToplam) {
        const { cantSort, sort, headTitle, useIndexes } = this.props;

        const indMap = map.index;

        if (useIndexes)
            delete map.index;

        const cells = Object.keys(map);

        if (indMap) {
            cells.unshift("index");
            map.index = indMap;
        }

        return cells.map((key, i) => {
            const it = map[key];
            const sortKey = it.sortKey || key;
            const st = {};
            const props = {};
            const cl = [];
            const hasSort = isHeader && sort.indexOf(sortKey) > -1;
            let isDesc = false;

            if (it.size) {
                st.width = it.size;
                st.minWidth = it.size;
            }

            if (!cantSort && isHeader && !it.cantSort) {
                cl.push("hand");

                if (hasSort) {
                    cl.push("sort");

                    if (sort[0] === "-")
                        isDesc = true;
                }

                props.onClick = this.changeSort.bind(this, sortKey);
            }

            if (it?.onClick?.apply)
                props.onClick = it.onClick.bind(null, info);

            if (useIndexes && key === "index")
                props.onMouseDown = this._indexChangeStart.bind(this, info);

            const fontStyle = (isHeader && headTitle) ? "blockTitle" : "p1";

            cl.push(fontStyle);

            if (it?.style && !isHeader)
                cl.push(it.style);

            if (it?.styleHeader && isHeader)
                cl.push(it.styleHeader);

            if (it?.className)
                cl.push(`${it.className}Cell`);

            return (
                <div
                    key={i}
                    className={`cell text ${cl.join(" ")}`}
                    style={st}
                    {...props}
                >
                    {!isHeader && !isToplam && this.getTypeCell(key, it, info)}
                    {isHeader && (
                        <div className="flex between centerV" style={{ textWrap: "wrap" }}>
                            {it.type === "check" && <CheckBox
                                ref={el => this["checkBoxMain"] = el}
                                onClick={this.clickCheck.bind(this, it.click)}
                            />}
                            {!it.hideLabel && this._helper.string.capitalize(this.tr(it.label))}
                            {hasSort && <ArrowIcon className={isDesc ? "rotate90m" : "rotate90"} />}

                        </div>
                    )}
                    {isToplam && (
                        <div className={`text blockTitle`}>
                            {this.getTypeCell(key, it, info)}
                        </div>
                    )}
                </div>
            );
        });
    }

    insertRow(i, map, info, rowProps, isToplam = false) {
        const isHeader = i === -1;

        let cl = ["row", `row${i}`];
        let key = i;

        let clickCb = null;
        if (!isHeader && rowProps) {
            const { useIds, format, click } = rowProps;

            if (useIds) {
                cl.push("row" + info.id);
                key = "row" + info.id;
            }

            if (format?.apply)
                cl = format(info, cl);
            if (click?.apply)
                clickCb = click.bind(null, info);

            if (i === this.props.selectedRow)
                cl.push("red");
        }

        return (
            <div
                key={key}
                className={cl.join(" ")}
                onClick={clickCb}>
                {this.renderCells(isHeader, map, info, isToplam)}
            </div>
        );
    }

    renderItems(map, items, rowProps) {
        return items.map((it, i) => this.insertRow(i, map, it, rowProps));
    }

    render() {
        const { className, map, items, rowProps, headBlack1, scrollNo, transparentBorder, useIndexes, useToplam } = this.props;
        const cl = [];

        if (!scrollNo)
            cl.push("flex1 minH0 pos rel scrolling all");
        if (transparentBorder)
            cl.push("transparent");

        if (useIndexes)
            map.index = { hideLabel: true, size: "15px", className: "index", type: "index" };

        return (
            <div
                ref={el => this.domNode = el}
                className={`tableItem flex rad8 ${cl.join(" ")}`}
            >
                <div
                    ref={el => this.inputItem = el}
                    className={`table w100 ${className} ${scrollNo ? "" : "pos abs sideAll"}`}
                >
                    <div
                        ref={el => this.headerNode = el}
                        className={`thead ${scrollNo ? "" : "pos sticky"} ${headBlack1 ? "headBlack1" : ""}`}>
                        {this.insertRow(-1, map, [])}
                    </div>
                    <div className="tbody">
                        {this.renderItems(map, items, rowProps)}
                        {Object.keys(useToplam)?.length > 0 && this.insertRow(items.length, map, useToplam, {}, true)}
                    </div>
                </div>
            </div>
        );
    }
}
